import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import DocumentHeader from '../../../components/DocumentHeader';
import DocumentWrapper from '../../../components/DocumentWrapper';
import FormEditingHandler from '../../../containers/FormEditingHandler';

import UPDRSForm from './Form';
import { docType, TDocument } from '../utils';

import DBSEffectHistory from './HistoryRowData/DBSEffect';
import UPDRSIIIHistory from './HistoryRowData/III';
import FTMTRSHistory from './HistoryRowData/FTMTRS';
import LevodopatestHistory from './HistoryRowData/Levodopatest';
import UPDRSVHistory from './HistoryRowData/V';

const fm = (id: string, values?: { [key: string]: string | number | null | React.JSX.Element }): React.JSX.Element => (
  <FormattedMessage id={id} values={values || undefined} />
);

const UPDRSHistory = (
  documents: Array<TDocument>,
  startEdit: (document: TAnyObject) => (e: React.MouseEvent<Element, MouseEvent>) => void,
  view?: IView,
): React.JSX.Element => {
  const VDocs: IUPDRSV[] = documents.filter(d => d._type === 'updrs_v');
  const IIIDocs: IUPDRSIII[] = documents.filter(d => d._type === 'updrs_iii');
  const ftmtrsDocs: IFTMTRS[] = documents.filter(d => d._type === 'ftmtrs');
  const LevodopaDocs: ILevodopatest[] = documents.filter(d => d._type === 'levodopatest');
  const DBSEffectDocs: IDBSEffect[] = documents.filter(d => d._type === 'dbsEffect');
  return (
    <React.Fragment>
      <UPDRSVHistory documents={VDocs} startEdit={startEdit} view={view} />

      <UPDRSIIIHistory documents={IIIDocs} startEdit={startEdit} view={view} />

      <FTMTRSHistory documents={ftmtrsDocs} startEdit={startEdit} view={view} />

      <LevodopatestHistory documents={LevodopaDocs} allDocuments={documents} startEdit={startEdit} view={view} />

      <DBSEffectHistory documents={DBSEffectDocs} allDocuments={documents} startEdit={startEdit} view={view} />
    </React.Fragment>
  );
};

const UPDRS = ({ documents }: IOwnProps): React.JSX.Element => (
  <FormEditingHandler name="updrs" documents={documents}>
    {(
      editing,
      startEdit,
      formData,
      view?: IView,
      _saveDraft?: (id: string) => (event: React.MouseEvent) => void,
      setSubDocuments?: (subDocuments: { name: string; id: string }[]) => void,
    ): React.JSX.Element => (
      <DocumentWrapper>
        <DocumentHeader
          name={'updrs'}
          headerId={
            docType(editing, documents, view?.viewing) === 'updrs_iii'
              ? 'updrs.updrsIII'
              : docType(editing, documents, view?.viewing) === 'ftmtrs'
                ? 'updrs.ftmtrs'
                : docType(editing, documents, view?.viewing) === 'updrs_v'
                  ? 'updrs.updrsV'
                  : docType(editing, documents, view?.viewing) === 'levodopatest'
                    ? 'updrs.levodopatest'
                    : docType(editing, documents, view?.viewing) === 'dbsEffect'
                      ? 'updrs.dbsEffect'
                      : 'updrs.secondaryTitle'
          }
          editing={editing}
          editButtons={<div />}
          infoText={
            docType(editing, documents, view?.viewing) === 'updrs_iii' ? (
              fm('updrs.updrsIIIInfo', { ln: <br /> })
            ) : docType(editing, documents, view?.viewing) === 'updrs_v' ? undefined : docType(
                editing,
                documents,
                view?.viewing,
              ) === 'levodopatest' ? (
              <div>
                {fm('updrs.levodopaDescription.header_execution')}
                <ul>
                  <li>{fm('updrs.levodopaDescription.1_patient12hWithoutMed')}</li>
                  <li>{fm('updrs.levodopaDescription.2_motorEstimate')}</li>
                  <li>{fm('updrs.levodopaDescription.3_patientMedication')}</li>
                  <li>{fm('updrs.levodopaDescription.4_updrsiiiTest')}</li>
                </ul>
                <br />
                {fm('updrs.levodopaDescription.ps_info')}
              </div>
            ) : docType(editing, documents, view?.viewing) === 'dbsEffect' ? (
              <div>
                {fm('updrs.dbsDescription.header_execution')}
                <ul>
                  <li>{fm('updrs.dbsDescription.1_patient12hWithoutMed')}</li>
                  <li>{fm('updrs.dbsDescription.2_motorEstimate')}</li>
                  <li>{fm('updrs.dbsDescription.3_patientDBSsetting')}</li>
                  <li>{fm('updrs.dbsDescription.4_updrsiiiTest')}</li>
                </ul>
                <br />
                {fm('updrs.dbsDescription.ps_info')}
              </div>
            ) : undefined
          }
        />
        {editing && documents?.find(d => d._id === editing) ? (
          <UPDRSForm
            formData={formData}
            document={documents?.find(d => d._id === editing) as TDocument}
            documents={documents}
            setSubDocuments={setSubDocuments}
          />
        ) : null}
        {view?.viewing && documents?.find(d => d._id === view.viewing) ? (
          <UPDRSForm
            formData={{ document: view.document as IUPDRSIII }}
            document={documents?.find(d => d._id === view.viewing) as TDocument}
            documents={documents}
            viewing={!!view.viewing}
          />
        ) : null}
        {!editing && !view?.viewing ? UPDRSHistory(documents, startEdit, view) : undefined}
      </DocumentWrapper>
    )}
  </FormEditingHandler>
);

interface IOwnProps {
  documents: Array<TDocument>;
}

export default UPDRS;
